import { useCallback } from 'react';
import type { EmptyProperties } from 'ui';

type P = {
  isDefaultOrganization?: boolean;
};

export const useGetEmptyDescription = () =>
  useCallback(
    ({ isDefaultOrganization }: P): EmptyProperties['description'] => ({
      subtitle: isDefaultOrganization
        ? 'There are no channels here yet'
        : 'There are no channels here. Try scrolling through the tabs above to find BigHeart, where you can explore interesting content.',
      title: 'No channels in this organization',
    }),
    [],
  );
